import React from 'react'
import Retour from '../components/Retour'

function Watcher() {
  return (
    <div>
        <div>
    <div style={{textAlign:"center", display:"flex", justifyContent: "center", alignItems: "center"}}>
    <p style={{fontSize:"50px", marginTop: "30px",width:"90%", fontFamily: "Risque, cursive", color: "red"}}>Julia et son mari d’origine roumaine quittent les États-Unis pour emménager à Bucarest, où ce dernier a trouvé un nouvel emploi. Ayant tiré récemment un trait sur sa carrière de comédienne, Julia se retrouve souvent seule dans son grand appartement et essaye de s’occuper comme elle peut. Une nuit, en scrutant par la fenêtre l’immeuble d’en face, elle aperçoit une silhouette qui semble la regarder en retour…</p>
    </div>
    <div style={{textAlign:"center"}}> <Retour /></div>
    </div>
    </div>
  )
}

export default Watcher